import { useTranslation } from 'react-i18next';

export default function About() {
  const { t } = useTranslation('common');

  const stats = [
    { value: '15+', label: t('about.experience') },
    { value: '5000+', label: t('about.products') },
    { value: '2000+', label: t('about.customers') },
    { value: '25+', label: t('about.countries') },
  ];

  return (
    <section id="about" className="py-10 md:py-20 bg-white">
      <div className="container mx-auto px-3 md:px-6">
        <div className="grid md:grid-cols-2 gap-6 md:gap-12 items-center">
          <div>
            <h2 className="text-2xl md:text-4xl font-bold text-gray-900 mb-3 md:mb-6">
              {t('about.title')}
            </h2>
            <p className="text-xs md:text-base text-gray-600 mb-4 md:mb-8 leading-relaxed">
              {t('about.description')}
            </p>
            <div className="grid grid-cols-2 gap-3 md:gap-6">
              {stats.map((stat, index) => (
                <div key={index} className="text-center p-3 md:p-6 bg-gray-50 rounded-lg">
                  <div className="text-xl md:text-4xl font-bold text-teal-600 mb-1 md:mb-2">
                    {stat.value}
                  </div>
                  <div className="text-[9px] md:text-sm text-gray-600">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>
          <div className="relative h-64 md:h-96 lg:h-[500px] rounded-lg overflow-hidden">
            <img
              src="https://public.readdy.ai/ai/img_res/1f197338265f59bf7a25224ebac8fa8e.jpg"
              alt="About GB Group"
              className="w-full h-full object-cover object-top"
            />
          </div>
        </div>
      </div>
    </section>
  );
}